import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CButton = (props) => {
  const IsOutline = props.IsOutline;

  const variant =
    IsOutline === true
      ? `btn-outline-${props.outlineVariant}`
      : `btn-${props.BtnVariant}`;

  const btnBlock = props.btnBlock === true ? "d-grid" : "";

  const btnCustomStyle =
    props.btnCustomStyle === undefined ? {} : props.btnCustomStyle;

  const btnClasses = props.btnClasses === undefined ? "" : props.btnClasses;

  const btnClassesDiv =
    props.btnClassesDiv === undefined ? "" : props.btnClassesDiv;

  const faIcon = props.faIcon === undefined ? "" : props.faIcon;
  const faTitle = props.faTitle === undefined ? "" : props.faTitle;
  const faClass = props.faClass === undefined ? "" : props.faClass;

  return (
    <>
      <div className={`${btnBlock} ${btnClassesDiv}`}>
        <button
          className={`${btnClasses} ${variant}`}
          style={btnCustomStyle}
          onClick={() =>
            props.functionName === undefined
              ? console.log()
              : props.functionName()
          }
        >
          <FontAwesomeIcon icon={faIcon} title={faTitle} className={faClass} />
          {props.innertext}
        </button>
      </div>
    </>
  );
};

export default CButton;
